import React, { PureComponent } from 'react'

import classNames from 'classnames'

import defaultIcon from './assets/icon_pdf.png'
import './style.scss'

const documentIcons = {
  bmp: 'image/bmp',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  gif: 'image/gif',
  jpg: 'image/jpg',
  jpeg: 'image/jpeg',
  pdf: 'application/pdf',
  png: 'image/png',
  rtf: 'application/rtf',
  txt: 'text/plain',
  xsl: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

function downloadDocuments(doc) {
  window.open(doc.fileUrl, '_blank')
}

export default class DocumentItem extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      icon: defaultIcon
    }
  }

  componentDidMount() {
    this.getDocImagePreview(this.props.doc.fileFormat)
  }

  getDocImagePreview = (docType) => {
    for (let object in documentIcons) {
      if (documentIcons[object].indexOf(docType) > -1) {
        const iconKey = Object.values(object).join('')
        try {
          import(`./assets/icon_${iconKey}.png`).then((module) =>
            this.setState({ icon: module.default })
          )
        } catch (error) {
          console.error(error)
        }
      }
    }
  }

  render() {
    const { doc, tryDelete } = this.props

    return (
      <li className={classNames(['user-downloaded-pdf', this.props.className])}>
        {tryDelete && (
          <button
            className='user-downloaded-pdf__button-delete pdf-remove-button'
            onClick={() => tryDelete(doc.id)}
          >
            <svg xmlns='http://www.w3.org/2000/svg' width='28' height='22' viewBox='0 0 28 22'>
              <path
                fill='#770358'
                d='M13.989 2A7.99 7.99 0 0 0 6 9.99 7.99 7.99 0 1 0 13.989 2zm3.435 10.154l-1.273 1.27s-2.013-2.16-2.163-2.16c-.148 0-2.162 2.16-2.162 2.16l-1.273-1.27s2.162-1.984 2.162-2.16c0-.18-2.162-2.165-2.162-2.165l1.273-1.274s2.03 2.162 2.162 2.162c.133 0 2.163-2.162 2.163-2.162l1.273 1.274s-2.163 2.013-2.163 2.164c0 .144 2.163 2.16 2.163 2.16z'
              />
            </svg>
          </button>
        )}
        <img
          className='user-downloaded-pdf__image'
          src={this.state.icon}
          alt={doc.fileFormat}
          onClick={() => downloadDocuments(doc)}
        />
        <p className='user-downloaded-pdf__name'>{doc.name}</p>
      </li>
    )
  }
}
